import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api, image_api } from '../../../constant';
import { Link, useNavigate, useLocation } from "react-router-dom";

const ProductMaster = () => {
  const tableHeaders = ["#", "Product ", "Quantity", "Unit Price", "Total", ];
  const [productData, setProductData] = useState([]);
    const [BillingData, setBillingData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
      const bill_id = localStorage.getItem("bill_id");

  const [formData, setFormData] = useState({
    id: null,
    billibg_id:bill_id,
    product_id: '',
    qty: '',
    unit_price: '',
    total: '',
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadInitialData();
    fetchBillingData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchProductData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

 const fetchBillingData = async () => {
  const bill_id = localStorage.getItem("bill_id");

  try {
    const res = await axios.get(`${var_api}veemart-billing/get/${bill_id}`);

    // Extract details array safely
    const detailsArray = res.data?.details && Array.isArray(res.data.details)
      ? res.data.details
      : [];

    setBillingData(detailsArray);
  } catch {
    toast.error("Failed to fetch billing data");
    setBillingData([]);
  }
};

  const fetchProductData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
    
    // Safely get array from response
    const allProducts = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data?.data)
      ? res.data.data
      : [];

    setProductData(allProducts);
  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch product data");
    setProductData([]); // fallback to empty array
  }
};

const getProductName = (id) => {
  const product = productData.find(p => p.id === id || p.product_id === id);
  return product ? product.product_name : "N/A";
};



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
    
    if (name === 'qty' || name === 'unit_price') {
      const qty = name === 'qty' ? value : formData.qty;
      const price = name === 'unit_price' ? value : formData.unit_price;
      setFormData(prev => ({ ...prev, total: qty && price ? (parseFloat(qty) * parseFloat(price)).toFixed(2) : '' }));
    }
  };

  const handleAddClick = () => {
    setFormData({ id: null,    billibg_id:bill_id,
 product_id: '', qty: '', unit_price: '', total: '' });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.product_id.trim()) newErrors.product_id = "Product ID is required";
    if (!formData.qty) newErrors.qty = "Quantity is required";
    if (!formData.unit_price) newErrors.unit_price = "Unit Price is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}veemart-billing/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}veemart-billing/post`, formData);
      }

      toast.success(res?.data?.message || "Product saved successfully!");
      setShowModal(false);
      setFormData({ id: null,    billibg_id:bill_id,
 product_id: '', qty: '', unit_price: '', total: '' });
      fetchProductData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save product");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = BillingData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search product..."
                  value={searchQuery}
                  onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                />
                {/* <Button variant="secondary" onClick={handleAddClick}>Add</Button> */}
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                         <td>{getProductName(item.product_id)}</td>                          <td>{item.qty}</td>
                          <td>{item.unit_price}</td>
                          <td>{item.total}</td>
                          {/* <td >
                            <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                                                           <i className="fas fa-pencil-alt"></i>
                                                         </Link>
                          </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button key={idx} variant={currentPage === idx + 1 ? "primary" : "light"} onClick={() => setCurrentPage(idx + 1)} className="me-1">
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Product" : "Add Product"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Product ID <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="text" name="product_id" value={formData.product_id} placeholder="Enter Product ID" onChange={handleInputChange} />
                    {errors.product_id && <div className="text-danger small mt-1">{errors.product_id}</div>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Quantity <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="number" name="qty" value={formData.qty} placeholder="Enter Quantity" onChange={handleInputChange} />
                    {errors.qty && <div className="text-danger small mt-1">{errors.qty}</div>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Unit Price <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="number" name="unit_price" value={formData.unit_price} placeholder="Enter Unit Price" onChange={handleInputChange} />
                    {errors.unit_price && <div className="text-danger small mt-1">{errors.unit_price}</div>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Total</Form.Label>
                    <Form.Control type="text" name="total" value={formData.total} readOnly />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button variant={isEditMode ? "warning" : "secondary"} type="submit" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : isEditMode ? "Update" : "Create"}
                </Button>
                <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>Cancel</Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default ProductMaster;
